































import {Component, Vue} from "vue-property-decorator";
import Customer from "@/api/Customer";
import CustomerService from "@/service/CustomerService";
import Loading from "@/components/Shared/Loading.vue";
import CustomerPasswordEditFormView from "@/components/Dashboard/Customer/CustomerPasswordEditFormView.vue";

@Component({
  components: {CustomerPasswordEditFormView, Loading}
})
export default class DashboardBasicInfo extends Vue {
  private customer: Customer | null = null;
  private showPasswordChangeForm = false;

  async mounted() {
    this.$store.dispatch('loading/showLoadingModal');
    this.customer = await CustomerService.getCurrentCustomer();
    this.$store.dispatch('loading/hideLoadingModal');
  }

  showForm() {
    this.showPasswordChangeForm = true;
  }

  closeForm() {
    this.showPasswordChangeForm = false;
  }
}
